import { sha256 } from 'js-sha256';

const BUCKET_COUNT = 100;
const BYTES_USED = 4;

/**
 * Stable A/B bucket (0-99) of a user, derived from the Flex user UUID. The formula is shared
 * bit-for-bit with server/util/abBucket.js and VanSite Mail — change all of them or none:
 *
 *   id = userId.trim().toLowerCase()
 *   ab_bucket = uint32_bigEndian(SHA-256(UTF-8(id))[0..4]) % 100
 *
 * Synchronous and pure-JS on purpose: `crypto.subtle` is not guaranteed under the iOS app's
 * `app://` origin, and without it no iOS user would ever get a bucket.
 *
 * @param {string|null|undefined} userId Flex user UUID (with hyphens)
 * @returns {number|null} null without an ID
 */
export const computeAbBucket = (userId) => {
  if (typeof userId !== 'string') return null;
  const id = userId.trim().toLowerCase();
  if (!id) return null;
  const bytes = sha256.array(id).slice(0, BYTES_USED);
  const uint32 = bytes.reduce((acc, byte) => acc * 256 + byte, 0);
  return uint32 % BUCKET_COUNT;
};
